<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-1 border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Monitoreo en vivo de las rutas.
                Ves qué hizo cada ruta (visitas, pedidos, cobros)
                y su avance del día. Úsalo para tomar decisiones
                rápidas si hay retrasos o cambios.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Monitor de rutas
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Monitorea toda la actividad de la <b>ruta</b> en un viaje en base a sus procesos de ejecución de
          <b>cobranza/preventa/venta/entrega</b> y los materiales relacionados a los mismos.
        </div>
      </div>

      <div class="mt-6 flex shrink-0 items-center justify-center space-x-2 sm:ml-auto sm:mt-0">

        <!--<div class="flex shrink-0 py-1 px-3">
          <app-trip-datepicker [initialDate]="selectedTripPast" [showFuture]="false"
            (dateChange)="onDatePastSelected($event)"></app-trip-datepicker>
          <app-trip-datepicker [initialDate]="selectedTripFuture" [showFuture]="true"
            (dateChange)="onDateFutureSelected($event)"></app-trip-datepicker>
        </div>-->
        <!--<div class="flex flex-col sm:flex-row w-full mb-4 items-center  justify-center">-->
        <app-status-filters [selectedTripStatuses]="selectedTripStatuses"
          [showTripStatuses]="[TripStatus.ABIERTO, TripStatus.CARGANDO, TripStatus.EN_PROCESO, TripStatus.CERRADO, TripStatus.LIQUIDANDO, TripStatus.FINALIZADO, TripStatus.DOC_LIQUIDACION_CREADO, TripStatus.DOC_LIQUIDACION_APROBADO]" 
          [tripStatusOptions]="tripStatusOptions"
          [typeFilter]="'tripStatus'" (selectionFilterApply)="onTripStatusFilterChange()">
        </app-status-filters>

        <app-status-filters [selectedRouteFunction]="selectedRouteFunction" [showRouteFunction]="true"
          [routeFunctionOptions]="routeFunctionOptions" [typeFilter]="'routeFunction'"
          (selectionFilterApply)="onRouteFunctionFilterChange()">
        </app-status-filters>

        <app-status-filters [modeTreeMonitor]="modeTreeMonitor" [typeFilter]="'master'" [showTreeModeMonitor]="true"
          (selectionFilterApply)="findAllWithCountTree()" (selectionFilterApplyTree)="onChangePointTree($event)">
        </app-status-filters>
        <!--</div>-->

        <mat-icon [matTooltip]="
                  isShowGrap ? 'Ocultar estadisticas' : 'Mostrar estadisticas'
                " (click)="onHandleGraph()" svgIcon="heroicons_solid:chart-bar" color="primary">
        </mat-icon>
        @if(isToday()){
        <button mat-icon-button color="primary" (click)="openModalTrip()" matTooltip="Ver mapa">
          <mat-icon [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
        </button>
        }
        <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Información">
          <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
        </button>
        <app-trip-datepicker [showBothOptions]="true" [pastTotal]="selectedTripPast().total"
          [futureTotal]="selectedTripFuture().total" [pastData]="selectedTripPast()" [futureData]="selectedTripFuture()"
          [initialDate]="selectedTripPast()" [showFuture]="false"
          [isLoading]="isLoadingTripsFuture() || isLoadingTripsPast()"
          (menuOpened)="onMenuOpened()"
          (modeChanged)="onModeChanged($event)"
          (dateChange)="onDateSelected($event)">
        </app-trip-datepicker>

        <!--<button mat-stroked-button color="primary" matTooltip="Modo de vista" [matMenuTriggerFor]="actionMenu"
          (menuOpened)="isViewMenuOpen = true" (menuClosed)="isViewMenuOpen = false">
          <div class="flex items-center">
            <div class="pr-2">
              <mat-icon [svgIcon]="'heroicons_outline:rectangle-stack'"></mat-icon>
            </div>
            <div class="flex flex-col p-2 content-center text-center gap-[3px] min-w-[60px]">
              <span class="font-light">Vista</span>
              <small class="font-bold" [innerText]="viewType()"></small>
            </div>

            <mat-icon [svgIcon]="isViewMenuOpen ? 'arrow_drop_up' : 'arrow_drop_down'"></mat-icon>
          </div>
        </button>

        <mat-menu #actionMenu="matMenu">
          <button mat-menu-item (click)="setViewType(ViewTypesOptions.AGENDA)" [ngClass]="{
                    'font-extrabold text-primary-600':
                      viewType() === ViewTypesOptions.AGENDA,
                  }">
            Agenda
          </button>
          <button mat-menu-item (click)="setViewType(ViewTypesOptions.RUTES)" [ngClass]="{
                    'font-bold text-primary-600':
                      viewType() === ViewTypesOptions.RUTES,
                  }">
            Rutas
          </button>
        </mat-menu>-->

        <mat-menu #filterMenu="matMenu">
          <button mat-menu-item [matMenuTriggerFor]="statusMenu">
            <span>Estados</span>
          </button>
          <button mat-menu-item [matMenuTriggerFor]="statusERPMenu">
            <span>Estados ERP</span>
          </button>
          <button mat-menu-item [matMenuTriggerFor]="customerMenu">
            <span>Cliente</span>
          </button>
        </mat-menu>

        <mat-menu #statusMenu="matMenu">
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:check-circle" style="color: rgb(65, 106, 218)"></mat-icon>
            <span>Activo</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:x-circle" style="color: rgb(141, 19, 19)"></mat-icon>
            <span>Anulado</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="mat_solid:checklist_rtl" style="color:rgb(9, 133, 50)"></mat-icon>
            <span>Entregado completamente al cliente</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="mat_solid:check" style="color:rgb(255, 136, 0)"></mat-icon>
            <span>Entregado parcialmente al cliente</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="mat_solid:indeterminate_check_box" style="color:rgb(255, 55, 0)"></mat-icon>
            <span>No entregado al cliente</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:play-circle" style="color: rgb(236, 199, 58)"></mat-icon>
            <span>En proceso de aprobación</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:exclamation-circle" style="color: rgb(236, 199, 58)"></mat-icon>
            <span>En espera de aprobación</span>
          </button>
          <button mat-menu-item>
            <mat-icon style="color: rgb(236, 199, 58)" aria-hidden="false" aria-label="Example home icon"
              fontIcon="local_shipping"></mat-icon>
            <span>En espera de recolección</span>
          </button>
          <button mat-menu-item>
            <mat-icon style="color: rgb(236, 199, 58)" aria-hidden="false" aria-label="Example home icon"
              fontIcon="swap_vert"></mat-icon>
            <span>En espera de cambio de producto</span>
          </button>
          <!-- <button mat-menu-item>
                  <mat-icon
                    svgIcon="heroicons_solid:play-circle"
                    style="color: rgb(236, 199, 58)"
                  ></mat-icon>
                  <span>En espera de recolección</span>
                </button> -->
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:check-circle" style="color: rgb(9, 133, 50)"></mat-icon>
            <span>Aprobado</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:check-circle" style="color:rgb(102, 205, 170)"></mat-icon>
            <span>Aprobado Parcialmente</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:x-circle" style="color: rgb(255, 0, 0)"></mat-icon>
            <span>Rechazado</span>
          </button>
        </mat-menu>
        <mat-menu #statusERPMenu="matMenu">
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:clock" style="color: rgb(233, 124, 61)"></mat-icon>
            <span>Pendiente envío a ERP</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:exclamation-triangle" style="color: rgb(141, 19, 19)"></mat-icon>
            <span>Error enviando a ERP</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:exclamation-triangle" style="color: rgb(255, 0, 0)"></mat-icon>
            <span>Error en ERP</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:document-arrow-up" style="color: rgb(65, 106, 218)"></mat-icon>
            <span>Enviado a ERP</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:document-arrow-down" style="color: rgb(236, 199, 58)"></mat-icon>
            <span>Recibido por ERP</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:clock" style="color: rgb(148, 46, 139)"></mat-icon>
            <span>Mod. pendiente de replicar</span>
          </button>
          <button mat-menu-item>
            <mat-icon svgIcon="heroicons_solid:document-check" style="color: rgb(9, 133, 50)"></mat-icon>
            <span>Creado en ERP</span>
          </button>
        </mat-menu>
        <mat-menu #customerMenu="matMenu">
          <button mat-menu-item>
            <mat-icon style="color: #2e7d32;">person</mat-icon>
            <span>Cliente Eventual</span>
          </button>
          <button mat-menu-item>
            <mat-icon style="color: #1976d2;">person_outline</mat-icon>
            <span>Consumidor Final</span>
          </button>
        </mat-menu>

      </div>
    </div>


    <!-- Cards Progress  screen 1.1 -->
    <ng-container *ngIf="isShowGrap">
      <div class="flex flex-col items-center justify-center w-full mt-4">
        <!-- Contenedor de tarjetas (centrado) -->
        <div class="flex flex-wrap items-center justify-center gap-4 px-2 w-full">
          <!-- Card No iniciado -->

          <div class="p-4 flex items-center">
            <div class="bg-indigo-100 px-3 py-2 rounded">
              <mat-icon class="text-indigo-500" svgIcon="heroicons_solid:lock-open"></mat-icon>
            </div>

            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">Abierta</p>
              <p class="text-2xl font-semibold">{{ statusOrders?.open }}</p>
            </div>
          </div>

          <!-- Card En Progreso -->
          <div class="p-4 flex items-center">
            <div class="bg-slate-100 px-3 py-2 rounded">
              <mat-icon class="text-slate-500">hourglass_empty</mat-icon>
            </div>

            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">En Espera</p>
              <p class="text-2xl font-semibold">{{ statusOrders?.pending }}</p>
            </div>
          </div>

          <!-- Card Liquidados -->
          <div class="p-4 flex items-center">
            <div class="bg-blue-100 px-3 py-2 rounded">
              <mat-icon class="text-blue-500" svgIcon="heroicons_solid:truck"></mat-icon>
            </div>

            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">En tránsito</p>
              <p class="text-2xl font-semibold">
                {{ statusOrders?.inTransit }}
              </p>
            </div>
          </div>

          <!-- Card Liquidados -->
          <div class="p-4 flex items-center">
            <div class="bg-green-100 px-3 py-2 rounded">
              <mat-icon class="text-green-500">done_all</mat-icon>
            </div>

            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">Liquidados</p>
              <p class="text-2xl font-semibold">
                {{ statusOrders?.settlement }}
              </p>
            </div>
          </div>
          <!-- Card Liquidados -->
          <div class="p-4 flex items-center">
            <div class="bg-orange-100 px-3 py-2 rounded">
              <mat-icon class="text-orange-500" svgIcon="heroicons_solid:lock-closed"></mat-icon>
            </div>

            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">Cerrada</p>
              <p class="text-2xl font-semibold">{{ statusOrders?.closed }}</p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
    <div class="pt-1 mx-6">

      @switch (viewType()) {
      @case (ViewTypesOptions.AGENDA) {
      <app-agenda-view [fetchAllWithCount]="fetchAllWithCount.bind(this)" [dataSource]="dataSource" [search]="search"
        [pinnedTripIds]="pinnedTripIds" [showOnlyPinned]="showOnlyPinned" (openPinnedModal)="openPinnedTripsModal()"
        (togglePinTrip)="togglePinTrip($event)">
      </app-agenda-view>
      }

      @case (ViewTypesOptions.RUTES) {
      <app-monitor-routes [fetchAllWithCount]="fetchAllWithCount.bind(this)" [dataSource]="dataSource" [search]="search"
        [companyList]="companyList" [modeTreeMonitor]="modeTreeMonitor" [pinnedTripIds]="pinnedTripIds"
        [showOnlyPinned]="showOnlyPinned" (openPinnedModal)="openPinnedTripsModal()"></app-monitor-routes>
      }
      }
    </div>
  </div>
  <!-- Nav bar Filter -->
  <app-filter (onFilterEvent)="handleFilterSearch()" (onCleanEvent)="clearFilters()">
    <form [formGroup]="form">
      <div class="w-full mb-4">
        <app-filter-section title="Rango de fechas" [expanded]="true">
          <app-dates-filters [form]="form" [submitted]="submitted" [showStartTrip]="true" [showEndTrip]="true"
            [showUploadTripDateRange]="true" />
        </app-filter-section>

        <app-filter-section title="Configuración" [expanded]="true">
          <app-configuration-filters [form]="form" [company]="true" [officeGroupByMongoId]="true"
            [salesOffice]="true"></app-configuration-filters>
        </app-filter-section>

        <app-filter-section title="Gestión de rutas" [expanded]="false">

          <app-routes-filters [form]="form" [type]="true" [route]="true" [function]="true"></app-routes-filters>
        </app-filter-section>

        <app-filter-section title="Vehículos" [expanded]="false">
          <div class="flex flex-col gap-4">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Multi-vehículo</mat-label>
              <mat-select formControlName="multiVehicle">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option [value]="true">Sí</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Multi-dispositivo</mat-label>
              <mat-select formControlName="multiDevice">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option [value]="true">Sí</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </app-filter-section>

        <app-filter-section title="Documentos de carga" [expanded]="false">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Docs. carga unificados</mat-label>
            <mat-select formControlName="hasUnifiedLoadDocs">
              <mat-option [value]="null">Todos</mat-option>
              <mat-option [value]="true">Sí</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
          </mat-form-field>
        </app-filter-section>
      </div>
    </form>
  </app-filter>
</mat-sidenav-container>